import { useState } from "react"
import { useTestConnectorMutation } from "../../../../../../redux/queries"

export const useConnectorTesting = () => {
  const [selectedRecordId, setSelectedRecordId] = useState<string>("")
  const [testResult, setTestResult] = useState<any>(null)

  const [testConnector, { isLoading: isTesting }] = useTestConnectorMutation()

  const handleTestOutgoing = async (connectorId: string) => {
    if (!connectorId || !selectedRecordId) return

    try {
      const result = await testConnector({
        connector_id: connectorId,
        record_id: selectedRecordId
      }).unwrap()

      setTestResult(result)
    } catch (error) {
      setTestResult({ status: "error", message: "Test failed", error })
    }
  }

  const clearSelection = () => {
    setSelectedRecordId("")
    setTestResult(null)
  }

  return {
    selectedRecordId,
    setSelectedRecordId,
    testResult,
    isTesting,
    handleTestOutgoing,
    clearSelection
  }
}
